import { ThumbnailProps } from 'core/thumbnail/thumbnail.props';
import { legacyTheme } from 'styles/theme';

export const ThumbnailPresets: ThumbnailProps = {
  alt: '',
  border: `1px solid ${legacyTheme.colors.cream}`,
  borderRadius: '3px',
  objectFit: 'contain',
  size: '5rem',
};
